<script setup>
import { ref, onMounted } from "vue";
import Layout from "../../layouts/main.vue";

const lang = ref("vi");

onMounted(() => {
  lang.value = localStorage.getItem("language") || "vi";
});
</script>

<template>
  <Layout>
    <div class="auth-page-wrapper">
      <div class="auth-page-content">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
              <div class="card-glass fade-in-up text-center">
                <div class="icon-container">
                  <!-- SVG Warning / Configuration Icon -->
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="64" height="64" class="warning-icon animate-pulse">
                    <path fill="none" d="M0 0h24v24H0z"/>
                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z" fill="rgba(240, 173, 78, 1)"/>
                  </svg>
                </div>

                <div class="text-content">
                  <h1 class="title">
                    {{ lang === "vi" ? "Tài khoản chưa được cấu hình" : "Account Not Fully Configured" }}
                  </h1>
                  <p class="description">
                    {{ lang === "vi" 
                      ? "Tài khoản của bạn chưa được cấu hình trang quản lý đầy đủ. Vui lòng liên hệ với quản trị viên hệ thống để được hỗ trợ." 
                      : "Your account is not fully configured with the management page. Please contact the system administrator for support." 
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.auth-page-wrapper {
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 180px); /* Đảm bảo căn giữa theo chiều dọc */
}

.card-glass {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
}

.fade-in-up {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.icon-container {
  margin-bottom: 24px;
}

.warning-icon {
  filter: drop-shadow(0 0 10px rgba(240, 173, 78, 0.5));
}

.animate-pulse {
  animation: pulse 2s infinite ease-in-out;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

.title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
  background: linear-gradient(90deg, #ff8a00, #e52e71);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.description {
  font-size: 16px;
  line-height: 1.6;
  color: #878a99; /* Màu chữ chuẩn theo style dự án */
  margin-bottom: 32px;
}

.footer {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 20px;
}

.support-info {
  font-size: 14px;
  color: #8e8e93;
}
</style>
